import axios from "axios";
import store from "../../redux/store";

// const BaseUrl = "http://192.168.1.113:4000/admin/";
// const BaseUrl = "http://192.168.1.87:3000/admin/";

const BaseUrl = "https://plazapalm.com/admin/";

// const BaseUrl = "http://192.168.1.9:3000/admin/";

const EndPoint = BaseUrl;
const Api = axios.create({
  timeout: 1000000,
  baseURL: EndPoint,
});

Api.defaults.headers.post["Content-Type"] = "application/json;charset=utf-8";
Api.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

Api.interceptors.request.use(
  (config) => {
    if (store.getState().auth.token !== null) {
      const token = ` ${store.getState().auth.token}`;
      // console.log(token)
      config.headers = {
        Authorization: token,
      };
    }
    return config;
  },
  (error) =>
    // Do something with request error
    Promise.reject(error)
);
// Add a response interceptor
Api.interceptors.response.use(
  (response) => {
    if (response.data.status === 401) {
      // store.dispatch(logout());
    } else {
      return response;
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

//post Api
export const postApi = async (url, data) => {
  try {
    let result = await Api.post(url, data);
    if (result.status === 200) {
      if (result.data.status === 200) {
        return result.data;
      } else {
        return result.data.message;
      }
    }
  } catch (e) {
    if (e) {
      return e;
    }
  }
};

//delete Api
export const deleteApi = async (url, data) => {
  try {
    let result = await Api.delete(url, data);
    if (result.status === 200) {
      if (result.data.status === 200) {
        return result.data;
      } else {
        return result.data.message;
      }
    }
  } catch (e) {
    if (e) {
      return e;
    }
  }
};

//get Api
export const getApi = async (url) => {
  // console.log(url , data , "get api----------")
  try {
    let result = await Api.get(url);
    // console.log(result)
    if (result.status === 200) {
      if (result.data.status === 200) {
        return result.data;
      } else {
        return result.data.message;
      }
    }
  } catch (e) {
    if (e) {
      
      return e;
    }
  }
};
